import styled from "styled-components";

type ContainerType = {
    background: string;
    border: string;
};

type IconOpsType = {
    color: string;
}


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  align-items: center;
`;

export const Content = styled.div<ContainerType>`
  display: flex;
  flex-direction: column;
  background: ${props => props.background};
  border-radius: 5px;
  border: 1px solid ${props => props.border};
`;

export const ContainerPermission = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  justify-content: space-between;
  align-items: flex-start;
`;
